import httpCustomer from "./httpServiceCustomer";

const apiEndpoint = "/salas";

export function getSalas() {    
    return httpCustomer.get(apiEndpoint);
}
